import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../Services/auth.service';
import { Permissions } from '../../../Enums/permission.enum';

export const permissionGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const required = route.data['permission'] as Permissions | Permissions[] | undefined;

  return authService.initializeAuth().pipe(
    map(() => {
      if (!required) {
        return true;
      }
      const user = authService.getCurrentUser();
      if (user?.hasPermission(required)) {
        return true;
      }
      return router.createUrlTree(['/']);
    })
  );
};
